import { render } from "./buildings_item.vue?vue&type=template&id=324c4732&scoped=true"
import script from "./buildings_item.vue?vue&type=script&lang=js"
export * from "./buildings_item.vue?vue&type=script&lang=js"

import "./buildings_item.vue?vue&type=style&index=0&id=324c4732&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324c4732"]])

export default __exports__